import React from "react";
import {IconsInterfaceTypes} from "./iconsInterface.types";

const checkIcon = ({color='#004CC6'}:IconsInterfaceTypes) =>
  <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.07573 9.26367L0.175729 5.34124C-0.0585762 5.10559 -0.0585762 4.72351 0.175729 4.48783L1.02424 3.63442C1.25854 3.39875 1.63846 3.39875 1.87277 3.63442L4.5 6.27673L10.1272 0.617169C10.3615 0.381517 10.7415 0.381517 10.9758 0.617169L11.8243 1.47058C12.0586 1.70623 12.0586 2.08831 11.8243 2.32399L4.92426 9.26369C4.68994 9.49935 4.31004 9.49935 4.07573 9.26367Z"
          fill={color}/>
  </svg>
export default checkIcon;
